// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Learning Resources - Beautiful & Responsive Styles
   ============================================ */

/* ============================================
   Common Styles
   ============================================ */

/* Section Headers */
.section-header-beautiful {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  padding: 20px 25px;
  margin-bottom: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 15px;
}

.section-header-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-header-icon i {
  font-size: 28px;
  color: white;
}

.section-header-icon.practice-icon {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.section-header-icon.parts-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.section-header-text {
  flex: 1 1;
  min-width: 200px;
}

.section-header-text h3 {
  margin: 0 0 5px 0;
  font-size: 22px;
  font-weight: 700;
  color: #333;
}

.section-header-text p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.section-header-count {
  background: white;
  border-radius: 15px;
  padding: 15px 25px;
  text-align: center;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.section-header-count .count-number {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
}

.section-header-count.practice-count .count-number {
  color: #11998e;
}

.section-header-count.parts-count .count-number {
  color: #4facfe;
}

.section-header-count .count-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* No Content Container */
.no-lessons-container,
.no-content-container {
  text-align: center;
  padding: 60px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  margin-top: 20px;
}

.no-lessons-icon,
.no-content-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.no-lessons-icon i,
.no-content-icon i {
  font-size: 36px;
  color: white;
}

.no-lessons-container h4,
.no-content-container h4 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.no-lessons-container p,
.no-content-container p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* ============================================
   Lessons Header (StepTwo)
   ============================================ */

.lessons-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 20px 25px;
  margin-bottom: 30px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  flex-wrap: wrap;
  gap: 15px;
}

.lessons-header-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.lessons-icon-wrapper {
  width: 55px;
  height: 55px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lessons-icon-wrapper i {
  font-size: 26px;
  color: white;
}

.lessons-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: white;
}

.lessons-subtitle {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.lessons-count-badge {
  background: white;
  color: #667eea;
  padding: 10px 20px;
  border-radius: 30px;
  font-weight: 700;
  font-size: 14px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.lessons-count-badge span {
  font-size: 20px;
}

/* ============================================
   Lesson Cards (StepTwo)
   ============================================ */

.lesson-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.lesson-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.lesson-card-header {
  position: relative;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.lesson-number {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.lesson-play-icon {
  font-size: 40px;
  opacity: 0.9;
  transition: transform 0.3s ease;
}

.lesson-card:hover .lesson-play-icon {
  transform: scale(1.2);
}

.lesson-card-decoration {
  position: absolute;
  bottom: -30px;
  right: -30px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
}

.lesson-card-body {
  padding: 15px;
  text-align: center;
}

.lesson-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.lesson-meta {
  margin-bottom: 12px;
}

.lesson-parts-badge {
  display: inline-flex;
  align-items: center;
  background: #f0f0f0;
  color: #666;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.lesson-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #667eea;
  font-size: 12px;
  font-weight: 600;
  transition: gap 0.3s ease;
}

.lesson-card:hover .lesson-action {
  gap: 12px;
}

/* ============================================
   Part Cards (StepThree)
   ============================================ */

.part-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.part-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.part-card-header {
  position: relative;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.part-number-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.part-play-button {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  transition: all 0.3s ease;
}

.part-card:hover .part-play-button {
  transform: scale(1.15);
  background: rgba(255, 255, 255, 0.4);
}

.part-card-decoration {
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
}

.part-card-body {
  padding: 15px;
  text-align: center;
}

.part-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.part-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #667eea;
  font-size: 11px;
  font-weight: 600;
  transition: gap 0.3s ease;
}

.part-card:hover .part-action {
  gap: 10px;
}

/* ============================================
   Animation Video Cards
   ============================================ */

.animation-videos-section {
  padding: 10px 0;
}

.animation-video-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
}

.animation-video-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.video-card-thumbnail {
  position: relative;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-play-button {
  width: 65px;
  height: 65px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #667eea;
  z-index: 2;
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.animation-video-card:hover .video-play-button {
  transform: scale(1.15);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.video-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.animation-video-card:hover .video-card-overlay {
  background: rgba(0, 0, 0, 0.2);
}

.video-number-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  z-index: 2;
}

.video-card-body {
  padding: 18px;
}

.video-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-meta {
  margin-bottom: 12px;
}

.video-type {
  display: inline-flex;
  align-items: center;
  background: #f5f0ff;
  color: #667eea;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.video-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #667eea;
  font-size: 13px;
  font-weight: 600;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.animation-video-card:hover .video-action i {
  transform: translateX(5px);
}

.video-action i {
  transition: transform 0.3s ease;
}

/* ============================================
   Assessment/Practice Cards
   ============================================ */

.assessment-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
}

.assessment-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.assessment-card.locked {
  opacity: 0.8;
  cursor: not-allowed;
}

.assessment-card.locked:hover {
  transform: none;
}

.assessment-card-header {
  position: relative;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.assessment-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.assessment-icon i {
  font-size: 24px;
  color: white;
}

.assessment-number {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.completed-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.95);
  color: #11998e;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
}

.assessment-card-body {
  padding: 20px;
  background: white;
}

.assessment-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.4;
}

.assessment-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 12px;
  flex: 1 1;
  min-width: 100px;
}

.stat-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon i {
  font-size: 14px;
  color: white;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.stat-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pass-marks-section {
  margin-bottom: 15px;
}

.pass-marks-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}

.pass-marks-progress {
  height: 6px;
  border-radius: 3px;
  background: #e9ecef;
}

.pass-marks-progress .progress-bar {
  border-radius: 3px;
}

.locked-message {
  background: #fff3cd;
  color: #856404;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.assessment-action {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.assessment-action.locked {
  background: #ccc;
}

.assessment-card:hover .assessment-action:not(.locked) {
  transform: scale(1.02);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.assessment-card.completed .assessment-action {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

/* ============================================
   Custom Tab Styles
   ============================================ */

.custom-lesson-tabs {
  border: none;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
  padding: 8px;
  margin-bottom: 25px !important;
}

.custom-lesson-tabs .nav-link {
  border: none;
  border-radius: 10px;
  color: #666;
  font-weight: 600;
  padding: 12px 20px;
  margin-right: 5px;
  transition: all 0.3s ease;
}

.custom-lesson-tabs .nav-link:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

.custom-lesson-tabs .nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.custom-tab-title {
  display: flex;
  align-items: center;
}

.custom-tab-title i {
  font-size: 16px;
}

/* Custom Breadcrumb */
.custom-breadcrumb {
  background: transparent;
  padding: 0;
  margin-bottom: 20px;
}

.custom-breadcrumb .breadcrumb-item {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.custom-breadcrumb .breadcrumb-item:hover {
  transform: translateX(-5px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

/* ============================================
   Video Modal Styles
   ============================================ */

.video-modal-beautiful .modal-content {
  border: none;
  border-radius: 20px;
  overflow: hidden;
}

.video-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 20px;
}

.video-modal-header .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.video-modal-header .btn-close {
  filter: invert(1);
}

.video-modal-body {
  background: #000;
}

.video-modal-footer {
  border: none;
  padding: 15px 20px;
  background: #f8f9fa;
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 767.98px) {
  .section-header-beautiful {
    padding: 15px;
    flex-direction: column;
    text-align: center;
  }

  .section-header-icon {
    width: 50px;
    height: 50px;
  }

  .section-header-icon i {
    font-size: 24px;
  }

  .section-header-text h3 {
    font-size: 18px;
  }

  .section-header-text p {
    font-size: 12px;
  }

  .section-header-count {
    width: 100%;
    padding: 12px;
  }

  .section-header-count .count-number {
    font-size: 24px;
  }

  .lessons-header {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }

  .lessons-header-content {
    flex-direction: column;
  }

  .lessons-title {
    font-size: 18px;
  }

  .lessons-subtitle {
    font-size: 12px;
  }

  .lesson-card-header,
  .part-card-header {
    height: 80px;
  }

  .video-card-thumbnail {
    height: 120px;
  }

  .video-play-button {
    width: 55px;
    height: 55px;
    font-size: 24px;
  }

  .custom-lesson-tabs .nav-link {
    padding: 10px 12px;
    font-size: 12px;
  }

  .custom-tab-title i {
    font-size: 14px;
  }

  .stat-item {
    min-width: calc(50% - 5px);
  }

  .assessment-stats {
    gap: 8px;
  }
}

@media (max-width: 575.98px) {
  .custom-lesson-tabs {
    padding: 5px;
  }

  .custom-lesson-tabs .nav-link {
    padding: 8px 10px;
    font-size: 11px;
    margin-right: 3px;
  }

  .custom-tab-title i {
    display: none;
  }

  .video-title {
    font-size: 13px;
  }

  .lesson-name,
  .part-name {
    font-size: 12px;
  }
}

/* ============================================
   Animations
   ============================================ */

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.lessons-grid > div,
.parts-grid > div,
.animation-videos-grid > div,
.assessment-grid > div {
  animation: slideUp 0.4s ease-out;
  animation-fill-mode: both;
}

.lessons-grid > div:nth-child(1) { animation-delay: 0.05s; }
.lessons-grid > div:nth-child(2) { animation-delay: 0.1s; }
.lessons-grid > div:nth-child(3) { animation-delay: 0.15s; }
.lessons-grid > div:nth-child(4) { animation-delay: 0.2s; }
.lessons-grid > div:nth-child(5) { animation-delay: 0.25s; }
.lessons-grid > div:nth-child(6) { animation-delay: 0.3s; }

.parts-grid > div:nth-child(1) { animation-delay: 0.05s; }
.parts-grid > div:nth-child(2) { animation-delay: 0.1s; }
.parts-grid > div:nth-child(3) { animation-delay: 0.15s; }
.parts-grid > div:nth-child(4) { animation-delay: 0.2s; }
.parts-grid > div:nth-child(5) { animation-delay: 0.25s; }
.parts-grid > div:nth-child(6) { animation-delay: 0.3s; }

.animation-videos-grid > div:nth-child(1) { animation-delay: 0.05s; }
.animation-videos-grid > div:nth-child(2) { animation-delay: 0.1s; }
.animation-videos-grid > div:nth-child(3) { animation-delay: 0.15s; }
.animation-videos-grid > div:nth-child(4) { animation-delay: 0.2s; }

.assessment-grid > div:nth-child(1) { animation-delay: 0.05s; }
.assessment-grid > div:nth-child(2) { animation-delay: 0.1s; }
.assessment-grid > div:nth-child(3) { animation-delay: 0.15s; }
.assessment-grid > div:nth-child(4) { animation-delay: 0.2s; }

/* Shimmer effect on hover */
.lesson-card::before,
.part-card::before,
.animation-video-card::before,
.assessment-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
  z-index: 10;
  pointer-events: none;
}

.lesson-card:hover::before,
.part-card:hover::before,
.animation-video-card:hover::before,
.assessment-card:hover::before {
  left: 100%;
}

/* ============================================
   Exams Page Styles
   ============================================ */

/* Exams Page Header */
.exams-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 25px 30px;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
  flex-wrap: wrap;
  gap: 20px;
}

.exams-page-header.exam-list-header {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  box-shadow: 0 10px 40px rgba(240, 147, 251, 0.3);
}

.exams-header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.exams-header-icon {
  width: 65px;
  height: 65px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exams-header-icon i {
  font-size: 30px;
  color: white;
}

.exams-header-icon.exam-icon {
  background: rgba(255, 255, 255, 0.25);
}

.exams-header-text h2 {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 5px 0;
}

.exams-header-text p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  margin: 0;
}

.exams-header-count {
  background: white;
  border-radius: 15px;
  padding: 15px 25px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.exams-header-count .count-number {
  display: block;
  font-size: 32px;
  font-weight: 700;
  color: #667eea;
  line-height: 1;
}

.exams-header-count.exam-count .count-number {
  color: #f5576c;
}

.exams-header-count .count-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Exam Subject Cards */
.exam-subject-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
}

.exam-subject-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.exam-subject-header {
  position: relative;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.exam-subject-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: transform 0.3s ease;
}

.exam-subject-card:hover .exam-subject-icon {
  transform: scale(1.1);
}

.exam-subject-icon i {
  font-size: 28px;
  color: white;
}

.exam-decoration-circle {
  position: absolute;
  bottom: -30px;
  right: -30px;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
}

.exam-subject-body {
  padding: 20px;
  text-align: center;
}

.exam-subject-name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.exam-subject-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #667eea;
  font-size: 13px;
  font-weight: 600;
  transition: gap 0.3s ease;
}

.exam-subject-card:hover .exam-subject-action {
  gap: 12px;
}

/* Exam Cards (Subject-wise Exam List) */
.exam-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);
  position: relative;
}

.exam-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.exam-card.locked {
  opacity: 0.85;
  cursor: not-allowed;
}

.exam-card.locked:hover {
  transform: none;
}

.exam-card-header {
  position: relative;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.exam-card-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-card-icon i {
  font-size: 24px;
  color: white;
}

.exam-card-number {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.exam-completed-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.95);
  color: #28a745;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
}

.exam-card-decoration {
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.exam-card-body {
  padding: 20px;
  background: white;
}

.exam-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.4;
}

.exam-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.exam-stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8f9fa;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: #666;
}

.exam-stat-item i {
  color: #667eea;
}

.exam-pass-section {
  margin-bottom: 15px;
}

.exam-pass-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}

.exam-pass-progress {
  height: 6px;
  border-radius: 3px;
  background: #e9ecef;
}

.exam-pass-progress .progress-bar {
  border-radius: 3px;
}

.exam-locked-message {
  background: #fff3cd;
  color: #856404;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.exam-card-action {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.exam-card-action.locked {
  background: #9e9e9e;
}

.exam-card:hover .exam-card-action:not(.locked) {
  transform: scale(1.02);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.exam-card.completed .exam-card-action {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

/* Exam Header Gradient Variant */
.exam-header-gradient {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
}

/* Exam Cards Grid Animation */
.exam-cards-grid > div,
.exam-subjects-grid > div {
  animation: slideUp 0.4s ease-out;
  animation-fill-mode: both;
}

.exam-cards-grid > div:nth-child(1),
.exam-subjects-grid > div:nth-child(1) { animation-delay: 0.05s; }
.exam-cards-grid > div:nth-child(2),
.exam-subjects-grid > div:nth-child(2) { animation-delay: 0.1s; }
.exam-cards-grid > div:nth-child(3),
.exam-subjects-grid > div:nth-child(3) { animation-delay: 0.15s; }
.exam-cards-grid > div:nth-child(4),
.exam-subjects-grid > div:nth-child(4) { animation-delay: 0.2s; }
.exam-cards-grid > div:nth-child(5),
.exam-subjects-grid > div:nth-child(5) { animation-delay: 0.25s; }
.exam-cards-grid > div:nth-child(6),
.exam-subjects-grid > div:nth-child(6) { animation-delay: 0.3s; }

/* Shimmer effect for exam cards */
.exam-card::before,
.exam-subject-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
  z-index: 10;
  pointer-events: none;
}

.exam-card:hover::before,
.exam-subject-card:hover::before {
  left: 100%;
}

/* Responsive Styles for Exams */
@media (max-width: 767.98px) {
  .exams-page-header {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .exams-header-content {
    flex-direction: column;
  }

  .exams-header-icon {
    width: 55px;
    height: 55px;
  }

  .exams-header-icon i {
    font-size: 26px;
  }

  .exams-header-text h2 {
    font-size: 20px;
  }

  .exams-header-count {
    width: 100%;
    padding: 12px;
  }

  .exams-header-count .count-number {
    font-size: 28px;
  }

  .exam-subject-header {
    height: 100px;
  }

  .exam-subject-icon {
    width: 50px;
    height: 50px;
  }

  .exam-subject-icon i {
    font-size: 24px;
  }

  .exam-card-title {
    font-size: 14px;
  }

  .exam-stats {
    gap: 6px;
  }

  .exam-stat-item {
    font-size: 11px;
    padding: 5px 10px;
  }
}

@media (max-width: 575.98px) {
  .exam-subject-name {
    font-size: 14px;
  }

  .exam-subject-action {
    font-size: 12px;
  }

  .exam-card-action {
    font-size: 12px;
    padding: 10px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/learning-resources.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;EAIE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;;AAE1D,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,qBAAqB,EAAE;;AAExD,4CAA4C,sBAAsB,EAAE;AACpE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,sBAAsB,EAAE;AACpE,4CAA4C,qBAAqB,EAAE;;AAEnE,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,qBAAqB,EAAE;AAC7D,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,qBAAqB,EAAE;;AAE7D,4BAA4B;AAC5B;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;iDAEiD;;AAEjD,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,iCAAiC;AACjC;EACE,wEAAwE;AAC1E;;AAEA,8BAA8B;AAC9B;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;yCACyC,sBAAsB,EAAE;AACjE;yCACyC,qBAAqB,EAAE;AAChE;yCACyC,sBAAsB,EAAE;AACjE;yCACyC,qBAAqB,EAAE;AAChE;yCACyC,sBAAsB,EAAE;AACjE;yCACyC,qBAAqB,EAAE;;AAEhE,kCAAkC;AAClC;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================\n   Learning Resources - Beautiful & Responsive Styles\n   ============================================ */\n\n/* ============================================\n   Common Styles\n   ============================================ */\n\n/* Section Headers */\n.section-header-beautiful {\n  display: flex;\n  align-items: center;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 20px;\n  padding: 20px 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.section-header-icon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.section-header-icon i {\n  font-size: 28px;\n  color: white;\n}\n\n.section-header-icon.practice-icon {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.section-header-icon.parts-icon {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n}\n\n.section-header-text {\n  flex: 1;\n  min-width: 200px;\n}\n\n.section-header-text h3 {\n  margin: 0 0 5px 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #333;\n}\n\n.section-header-text p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.section-header-count {\n  background: white;\n  border-radius: 15px;\n  padding: 15px 25px;\n  text-align: center;\n  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);\n}\n\n.section-header-count .count-number {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.section-header-count.practice-count .count-number {\n  color: #11998e;\n}\n\n.section-header-count.parts-count .count-number {\n  color: #4facfe;\n}\n\n.section-header-count .count-label {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* No Content Container */\n.no-lessons-container,\n.no-content-container {\n  text-align: center;\n  padding: 60px 20px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 20px;\n  margin-top: 20px;\n}\n\n.no-lessons-icon,\n.no-content-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n}\n\n.no-lessons-icon i,\n.no-content-icon i {\n  font-size: 36px;\n  color: white;\n}\n\n.no-lessons-container h4,\n.no-content-container h4 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.no-lessons-container p,\n.no-content-container p {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n}\n\n/* ============================================\n   Lessons Header (StepTwo)\n   ============================================ */\n\n.lessons-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 20px;\n  padding: 20px 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.lessons-header-content {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.lessons-icon-wrapper {\n  width: 55px;\n  height: 55px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lessons-icon-wrapper i {\n  font-size: 26px;\n  color: white;\n}\n\n.lessons-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n}\n\n.lessons-subtitle {\n  margin: 0;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.lessons-count-badge {\n  background: white;\n  color: #667eea;\n  padding: 10px 20px;\n  border-radius: 30px;\n  font-weight: 700;\n  font-size: 14px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.lessons-count-badge span {\n  font-size: 20px;\n}\n\n/* ============================================\n   Lesson Cards (StepTwo)\n   ============================================ */\n\n.lesson-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n}\n\n.lesson-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);\n}\n\n.lesson-card-header {\n  position: relative;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.lesson-number {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(255, 255, 255, 0.25);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.lesson-play-icon {\n  font-size: 40px;\n  opacity: 0.9;\n  transition: transform 0.3s ease;\n}\n\n.lesson-card:hover .lesson-play-icon {\n  transform: scale(1.2);\n}\n\n.lesson-card-decoration {\n  position: absolute;\n  bottom: -30px;\n  right: -30px;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 50%;\n}\n\n.lesson-card-body {\n  padding: 15px;\n  text-align: center;\n}\n\n.lesson-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 10px;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.lesson-meta {\n  margin-bottom: 12px;\n}\n\n.lesson-parts-badge {\n  display: inline-flex;\n  align-items: center;\n  background: #f0f0f0;\n  color: #666;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.lesson-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #667eea;\n  font-size: 12px;\n  font-weight: 600;\n  transition: gap 0.3s ease;\n}\n\n.lesson-card:hover .lesson-action {\n  gap: 12px;\n}\n\n/* ============================================\n   Part Cards (StepThree)\n   ============================================ */\n\n.part-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n}\n\n.part-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);\n}\n\n.part-card-header {\n  position: relative;\n  height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.part-number-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(255, 255, 255, 0.25);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.part-play-button {\n  width: 50px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.part-card:hover .part-play-button {\n  transform: scale(1.15);\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.part-card-decoration {\n  position: absolute;\n  bottom: -20px;\n  right: -20px;\n  width: 60px;\n  height: 60px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 50%;\n}\n\n.part-card-body {\n  padding: 15px;\n  text-align: center;\n}\n\n.part-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 10px;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.part-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #667eea;\n  font-size: 11px;\n  font-weight: 600;\n  transition: gap 0.3s ease;\n}\n\n.part-card:hover .part-action {\n  gap: 10px;\n}\n\n/* ============================================\n   Animation Video Cards\n   ============================================ */\n\n.animation-videos-section {\n  padding: 10px 0;\n}\n\n.animation-video-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);\n}\n\n.animation-video-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\n}\n\n.video-card-thumbnail {\n  position: relative;\n  height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.video-play-button {\n  width: 65px;\n  height: 65px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  color: #667eea;\n  z-index: 2;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n}\n\n.animation-video-card:hover .video-play-button {\n  transform: scale(1.15);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.video-card-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.1);\n  transition: background 0.3s ease;\n}\n\n.animation-video-card:hover .video-card-overlay {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.video-number-badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  z-index: 2;\n}\n\n.video-card-body {\n  padding: 18px;\n}\n\n.video-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 10px;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.video-meta {\n  margin-bottom: 12px;\n}\n\n.video-type {\n  display: inline-flex;\n  align-items: center;\n  background: #f5f0ff;\n  color: #667eea;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.video-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #667eea;\n  font-size: 13px;\n  font-weight: 600;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.animation-video-card:hover .video-action i {\n  transform: translateX(5px);\n}\n\n.video-action i {\n  transition: transform 0.3s ease;\n}\n\n/* ============================================\n   Assessment/Practice Cards\n   ============================================ */\n\n.assessment-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);\n}\n\n.assessment-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n.assessment-card.locked {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.assessment-card.locked:hover {\n  transform: none;\n}\n\n.assessment-card-header {\n  position: relative;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.assessment-icon {\n  width: 50px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.assessment-icon i {\n  font-size: 24px;\n  color: white;\n}\n\n.assessment-number {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.completed-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #11998e;\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 10px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.assessment-card-body {\n  padding: 20px;\n  background: white;\n}\n\n.assessment-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 15px;\n  line-height: 1.4;\n}\n\n.assessment-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f8f9fa;\n  padding: 8px 12px;\n  border-radius: 12px;\n  flex: 1;\n  min-width: 100px;\n}\n\n.stat-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stat-icon i {\n  font-size: 14px;\n  color: white;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 10px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.pass-marks-section {\n  margin-bottom: 15px;\n}\n\n.pass-marks-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 6px;\n}\n\n.pass-marks-progress {\n  height: 6px;\n  border-radius: 3px;\n  background: #e9ecef;\n}\n\n.pass-marks-progress .progress-bar {\n  border-radius: 3px;\n}\n\n.locked-message {\n  background: #fff3cd;\n  color: #856404;\n  padding: 10px 15px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.assessment-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.assessment-action.locked {\n  background: #ccc;\n}\n\n.assessment-card:hover .assessment-action:not(.locked) {\n  transform: scale(1.02);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.assessment-card.completed .assessment-action {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n/* ============================================\n   Custom Tab Styles\n   ============================================ */\n\n.custom-lesson-tabs {\n  border: none;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 15px;\n  padding: 8px;\n  margin-bottom: 25px !important;\n}\n\n.custom-lesson-tabs .nav-link {\n  border: none;\n  border-radius: 10px;\n  color: #666;\n  font-weight: 600;\n  padding: 12px 20px;\n  margin-right: 5px;\n  transition: all 0.3s ease;\n}\n\n.custom-lesson-tabs .nav-link:hover {\n  background: rgba(102, 126, 234, 0.1);\n  color: #667eea;\n}\n\n.custom-lesson-tabs .nav-link.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n.custom-tab-title {\n  display: flex;\n  align-items: center;\n}\n\n.custom-tab-title i {\n  font-size: 16px;\n}\n\n/* Custom Breadcrumb */\n.custom-breadcrumb {\n  background: transparent;\n  padding: 0;\n  margin-bottom: 20px;\n}\n\n.custom-breadcrumb .breadcrumb-item {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 25px;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.custom-breadcrumb .breadcrumb-item:hover {\n  transform: translateX(-5px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);\n}\n\n/* ============================================\n   Video Modal Styles\n   ============================================ */\n\n.video-modal-beautiful .modal-content {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.video-modal-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 15px 20px;\n}\n\n.video-modal-header .modal-title {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n\n.video-modal-header .btn-close {\n  filter: invert(1);\n}\n\n.video-modal-body {\n  background: #000;\n}\n\n.video-modal-footer {\n  border: none;\n  padding: 15px 20px;\n  background: #f8f9fa;\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 767.98px) {\n  .section-header-beautiful {\n    padding: 15px;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .section-header-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .section-header-icon i {\n    font-size: 24px;\n  }\n\n  .section-header-text h3 {\n    font-size: 18px;\n  }\n\n  .section-header-text p {\n    font-size: 12px;\n  }\n\n  .section-header-count {\n    width: 100%;\n    padding: 12px;\n  }\n\n  .section-header-count .count-number {\n    font-size: 24px;\n  }\n\n  .lessons-header {\n    flex-direction: column;\n    text-align: center;\n    padding: 15px;\n  }\n\n  .lessons-header-content {\n    flex-direction: column;\n  }\n\n  .lessons-title {\n    font-size: 18px;\n  }\n\n  .lessons-subtitle {\n    font-size: 12px;\n  }\n\n  .lesson-card-header,\n  .part-card-header {\n    height: 80px;\n  }\n\n  .video-card-thumbnail {\n    height: 120px;\n  }\n\n  .video-play-button {\n    width: 55px;\n    height: 55px;\n    font-size: 24px;\n  }\n\n  .custom-lesson-tabs .nav-link {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .custom-tab-title i {\n    font-size: 14px;\n  }\n\n  .stat-item {\n    min-width: calc(50% - 5px);\n  }\n\n  .assessment-stats {\n    gap: 8px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .custom-lesson-tabs {\n    padding: 5px;\n  }\n\n  .custom-lesson-tabs .nav-link {\n    padding: 8px 10px;\n    font-size: 11px;\n    margin-right: 3px;\n  }\n\n  .custom-tab-title i {\n    display: none;\n  }\n\n  .video-title {\n    font-size: 13px;\n  }\n\n  .lesson-name,\n  .part-name {\n    font-size: 12px;\n  }\n}\n\n/* ============================================\n   Animations\n   ============================================ */\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.lessons-grid > div,\n.parts-grid > div,\n.animation-videos-grid > div,\n.assessment-grid > div {\n  animation: slideUp 0.4s ease-out;\n  animation-fill-mode: both;\n}\n\n.lessons-grid > div:nth-child(1) { animation-delay: 0.05s; }\n.lessons-grid > div:nth-child(2) { animation-delay: 0.1s; }\n.lessons-grid > div:nth-child(3) { animation-delay: 0.15s; }\n.lessons-grid > div:nth-child(4) { animation-delay: 0.2s; }\n.lessons-grid > div:nth-child(5) { animation-delay: 0.25s; }\n.lessons-grid > div:nth-child(6) { animation-delay: 0.3s; }\n\n.parts-grid > div:nth-child(1) { animation-delay: 0.05s; }\n.parts-grid > div:nth-child(2) { animation-delay: 0.1s; }\n.parts-grid > div:nth-child(3) { animation-delay: 0.15s; }\n.parts-grid > div:nth-child(4) { animation-delay: 0.2s; }\n.parts-grid > div:nth-child(5) { animation-delay: 0.25s; }\n.parts-grid > div:nth-child(6) { animation-delay: 0.3s; }\n\n.animation-videos-grid > div:nth-child(1) { animation-delay: 0.05s; }\n.animation-videos-grid > div:nth-child(2) { animation-delay: 0.1s; }\n.animation-videos-grid > div:nth-child(3) { animation-delay: 0.15s; }\n.animation-videos-grid > div:nth-child(4) { animation-delay: 0.2s; }\n\n.assessment-grid > div:nth-child(1) { animation-delay: 0.05s; }\n.assessment-grid > div:nth-child(2) { animation-delay: 0.1s; }\n.assessment-grid > div:nth-child(3) { animation-delay: 0.15s; }\n.assessment-grid > div:nth-child(4) { animation-delay: 0.2s; }\n\n/* Shimmer effect on hover */\n.lesson-card::before,\n.part-card::before,\n.animation-video-card::before,\n.assessment-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.lesson-card:hover::before,\n.part-card:hover::before,\n.animation-video-card:hover::before,\n.assessment-card:hover::before {\n  left: 100%;\n}\n\n/* ============================================\n   Exams Page Styles\n   ============================================ */\n\n/* Exams Page Header */\n.exams-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 20px;\n  padding: 25px 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.exams-page-header.exam-list-header {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  box-shadow: 0 10px 40px rgba(240, 147, 251, 0.3);\n}\n\n.exams-header-content {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.exams-header-icon {\n  width: 65px;\n  height: 65px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.exams-header-icon i {\n  font-size: 30px;\n  color: white;\n}\n\n.exams-header-icon.exam-icon {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.exams-header-text h2 {\n  color: white;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 5px 0;\n}\n\n.exams-header-text p {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n  margin: 0;\n}\n\n.exams-header-count {\n  background: white;\n  border-radius: 15px;\n  padding: 15px 25px;\n  text-align: center;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n}\n\n.exams-header-count .count-number {\n  display: block;\n  font-size: 32px;\n  font-weight: 700;\n  color: #667eea;\n  line-height: 1;\n}\n\n.exams-header-count.exam-count .count-number {\n  color: #f5576c;\n}\n\n.exams-header-count .count-label {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Exam Subject Cards */\n.exam-subject-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);\n}\n\n.exam-subject-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\n}\n\n.exam-subject-header {\n  position: relative;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.exam-subject-icon {\n  width: 60px;\n  height: 60px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  transition: transform 0.3s ease;\n}\n\n.exam-subject-card:hover .exam-subject-icon {\n  transform: scale(1.1);\n}\n\n.exam-subject-icon i {\n  font-size: 28px;\n  color: white;\n}\n\n.exam-decoration-circle {\n  position: absolute;\n  bottom: -30px;\n  right: -30px;\n  width: 100px;\n  height: 100px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 50%;\n}\n\n.exam-subject-body {\n  padding: 20px;\n  text-align: center;\n}\n\n.exam-subject-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.exam-subject-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #667eea;\n  font-size: 13px;\n  font-weight: 600;\n  transition: gap 0.3s ease;\n}\n\n.exam-subject-card:hover .exam-subject-action {\n  gap: 12px;\n}\n\n/* Exam Cards (Subject-wise Exam List) */\n.exam-card {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.08);\n  position: relative;\n}\n\n.exam-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n.exam-card.locked {\n  opacity: 0.85;\n  cursor: not-allowed;\n}\n\n.exam-card.locked:hover {\n  transform: none;\n}\n\n.exam-card-header {\n  position: relative;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.exam-card-icon {\n  width: 50px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.exam-card-icon i {\n  font-size: 24px;\n  color: white;\n}\n\n.exam-card-number {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.exam-completed-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #28a745;\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 10px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.exam-card-decoration {\n  position: absolute;\n  bottom: -20px;\n  right: -20px;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.exam-card-body {\n  padding: 20px;\n  background: white;\n}\n\n.exam-card-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 15px;\n  line-height: 1.4;\n}\n\n.exam-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.exam-stat-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f8f9fa;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  color: #666;\n}\n\n.exam-stat-item i {\n  color: #667eea;\n}\n\n.exam-pass-section {\n  margin-bottom: 15px;\n}\n\n.exam-pass-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 6px;\n}\n\n.exam-pass-progress {\n  height: 6px;\n  border-radius: 3px;\n  background: #e9ecef;\n}\n\n.exam-pass-progress .progress-bar {\n  border-radius: 3px;\n}\n\n.exam-locked-message {\n  background: #fff3cd;\n  color: #856404;\n  padding: 10px 15px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.exam-card-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.exam-card-action.locked {\n  background: #9e9e9e;\n}\n\n.exam-card:hover .exam-card-action:not(.locked) {\n  transform: scale(1.02);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.exam-card.completed .exam-card-action {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n}\n\n/* Exam Header Gradient Variant */\n.exam-header-gradient {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n/* Exam Cards Grid Animation */\n.exam-cards-grid > div,\n.exam-subjects-grid > div {\n  animation: slideUp 0.4s ease-out;\n  animation-fill-mode: both;\n}\n\n.exam-cards-grid > div:nth-child(1),\n.exam-subjects-grid > div:nth-child(1) { animation-delay: 0.05s; }\n.exam-cards-grid > div:nth-child(2),\n.exam-subjects-grid > div:nth-child(2) { animation-delay: 0.1s; }\n.exam-cards-grid > div:nth-child(3),\n.exam-subjects-grid > div:nth-child(3) { animation-delay: 0.15s; }\n.exam-cards-grid > div:nth-child(4),\n.exam-subjects-grid > div:nth-child(4) { animation-delay: 0.2s; }\n.exam-cards-grid > div:nth-child(5),\n.exam-subjects-grid > div:nth-child(5) { animation-delay: 0.25s; }\n.exam-cards-grid > div:nth-child(6),\n.exam-subjects-grid > div:nth-child(6) { animation-delay: 0.3s; }\n\n/* Shimmer effect for exam cards */\n.exam-card::before,\n.exam-subject-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.exam-card:hover::before,\n.exam-subject-card:hover::before {\n  left: 100%;\n}\n\n/* Responsive Styles for Exams */\n@media (max-width: 767.98px) {\n  .exams-page-header {\n    flex-direction: column;\n    text-align: center;\n    padding: 20px;\n  }\n\n  .exams-header-content {\n    flex-direction: column;\n  }\n\n  .exams-header-icon {\n    width: 55px;\n    height: 55px;\n  }\n\n  .exams-header-icon i {\n    font-size: 26px;\n  }\n\n  .exams-header-text h2 {\n    font-size: 20px;\n  }\n\n  .exams-header-count {\n    width: 100%;\n    padding: 12px;\n  }\n\n  .exams-header-count .count-number {\n    font-size: 28px;\n  }\n\n  .exam-subject-header {\n    height: 100px;\n  }\n\n  .exam-subject-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .exam-subject-icon i {\n    font-size: 24px;\n  }\n\n  .exam-card-title {\n    font-size: 14px;\n  }\n\n  .exam-stats {\n    gap: 6px;\n  }\n\n  .exam-stat-item {\n    font-size: 11px;\n    padding: 5px 10px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .exam-subject-name {\n    font-size: 14px;\n  }\n\n  .exam-subject-action {\n    font-size: 12px;\n  }\n\n  .exam-card-action {\n    font-size: 12px;\n    padding: 10px 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
